'use client';
import { usePathname } from 'next/navigation';
import { Container, Link, Paper, Stack, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslate } from '@jd/i18n';

export default function NotFound() {
  const pathname = usePathname();
  const t = useTranslate('common.notFoundPage');
  return (
    <Container maxWidth={'md'} sx={{ height: '100%' }}>
      <Paper sx={{ p: 2, margin: 'auto', mt: '40%' }}>
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          <ErrorIcon sx={{ fontSize: '72px' }} color={'error'} />
          <Typography variant={'h4'}>{t('title', { pathname })}</Typography>
          <Typography>
            {t('goBack')} <Link href="/">{t('homePage')}</Link>
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
}
